import { render } from "./App.vue?vue&type=template&id=16036054&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=16036054&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=16036054&lang=css"
import "./App.vue?vue&type=style&index=2&id=16036054&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ss-wallet-staging/ss_wallet_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16036054"]])

export default __exports__